import About from "./components/about";
import Apidata from "./components/apidata";
import Details from "./components/details";
import Footer from "./components/footer";
import Header from "./components/header";
import Ourstatic from "./components/ourstatic";
import Scrollbar from "./components/scrollbar";
import Slider from "./components/slider";
import Upcoming from "./components/upcoming";

function Home() {
  return (
    <div>
      <Header />
      <Slider />
      <Scrollbar />
      <About />
      <Ourstatic />
      <Details />
      <Upcoming />
      <Apidata />
      <Footer />
    </div>
  );
}

export default Home;
